import { useEffect, useState } from "react";
import { RecentPostsPropTypes } from "./propTypes";
import clsx from "clsx";
import useStore from "@/hooks/useStore";
import PostCard from "@/components/utils/PostCard/PostCard";
import "./styles.scss";

/* #META
 {
  "NAME": "RecentPosts",
  "CLASSNAME": "recent-posts-component",
  "URL": "http://nicasource.local"
 }
#ENDMETA */

const RecentPosts = ({ data }) => {
  const {
    recent_posts_count: recentPostsCount = 1,
    recent_posts_in_grid: recentPostsInGrid = false,
    recent_posts_type: recentPostsType,
  } = data;

  const [posts, setPosts] = useState();

  const { getItems, requestedItems } = useStore();

  const postsRequest = {
    type: recentPostsType,
    params: {
      _embed: 1,
      order: "desc",
      orderby: "date",
      per_page: recentPostsCount,
    },
    showLoading: true,
  };

  const getPosts = () => {
    async function fetchData() {
      await getItems(postsRequest);
      setPosts(requestedItems(postsRequest));
    }

    fetchData();
  };

  useEffect(() => {
    getPosts();
  }, []);

  return (
    <section className="recent-posts-component component-module module-content">
      <div
        className={clsx({
          "grid-layout": recentPostsInGrid,
        })}
      >
        {posts?.map((el, index) => {
          let postProps = {
            isFeatured: !recentPostsInGrid,
            image: {
              url:
                el._embedded && el._embedded["wp:featuredmedia"]
                  ? el._embedded["wp:featuredmedia"][0].source_url
                  : null,
            },
            link: { title: el.title.rendered, url: el.link },
            title: el.title.rendered,
            type: recentPostsType,
          };

          const categories = [];

          if (el._embedded && el._embedded["wp:term"]) {
            el._embedded["wp:term"].forEach((term) => {
              term.forEach((val) => {
                if (val.taxonomy === "category") {
                  categories.push(val.name);
                }
              });
            });
          }

          postProps = { ...postProps, categories };

          return (
            <PostCard
              className={clsx({ "grid-card": recentPostsInGrid, "large-card": index % 3 === 0 })}
              key={index}
              {...postProps}
            />
          );
        })}
      </div>
    </section>
  );
};

RecentPosts.propTypes = RecentPostsPropTypes;

export default RecentPosts;
